export default{
    "my-patients":"My Patients",
    "patient-detail":"Patient Detail",
    "my-appointments":"My Appointments",
    "appointments":"My Appointments",
    "health-profile": "Health Information",
    "my-patientsdetails": "Patient History",
    "my-availability": "My Availability",
    "my-availability-new-version": "My Availability (Beta Version)",
    "dashboard": "Dashboard",
    "my-account": "My Profile",
    "my-account-child": "My Profile",
    "video-consultation":"Consultation",
    "select-assessment": "Take Assessment",
    "take-assessment":"Take Assessment",
    "emotion": "Self Assessment Depression",
    "stress": "Self Assessment Stress",
    "assessment-history": "Assessments",
    "score-details": "Assessment Score Details",
    "schedule-appointment": "New Appointment",
    "consultation-history": "Appointments",
    "select-doctor": "Select Doctor",
    "subscription-plan": "Membership Plan",
    "my-order": "My Orders",
    "select-tickets":"My Tickets",
    "tickets-list":"All Tickets",
    "search-patient":"Patients",
    "add-medicine":"Medicines",
    "doctor-availabilty":"Doctors",
    "org-records":"B2B Records",
    "analytics":"Analytics",
    "table":"Records",
    "consultation-list":"Consultations",
    "patient-lists":"Patient Details",
    "patient-plan":"Plan Statistics",
    "plan-history":"Plan History",
    "patient-records":"Patient Details",
    "patient-consultation":"Patient Consultations",
    "my-tickets":"My Tickets",
    "chat":"Chat",
    "manage-coupon":"Manage Coupons",
    "document-upload":"Document upload",
    "instructions":"Instructions",
    "offline-patient-register":"Offline Patient Registration",
    "new-user":"New Account Details",
    "release-note":"Release Note",
    "vital-form":"Vital Form",
    "billing":"Billing",
    "edit-bill":"Edit Billing",
    "search-vendor":"Vendor",
    "tickets":"Tickets",
    "user-management":"User Management",
    "edit-clinician":"Edit Clinician",
    "clinician-check-availability":"Check Availability",
    "ai-form-assistant":"AI Form Assistant",
}